import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { Check } from '../../../components/Icon';
import { WithVehicleProperty } from '../../Vehicles/components/WithVehicleProperty';
import { selectVehicleProperty } from '../../Vehicles/selectors';

const Container = styled.div``;

const STATE = {};

class InvoiceEmailStatusComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    if (!this.props.vehicleId) {
      return 'x';
    }

    return (
      // <WithVehicleProperty
      //   doFetch
      //   vehicleId={this.props.vehicleId}
      //   propertyName={this.props.invoice.direction == 'incoming' ? 'incoming_invoice_sent' : 'outgoing_invoice_sent'}
      // >
        <Container>{!!this.props.invoice?.emailSentAt ? <Check /> : null}</Container>
      // </WithVehicleProperty>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    status: selectVehicleProperty(
      ownProps.vehicleId,
      ownProps.invoice.direction == 'incoming' ? 'incoming_invoice_sent' : 'outgoing_invoice_sent',
    ),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const InvoiceEmailStatus = compose(
  withConnect,
  withRouter,
)(InvoiceEmailStatusComp);
